import store from 'store';
import Provinces, { getProvinceByName } from '../../helper/province';
import { getGenderByName } from '../../helper/gender';


  export function accountReducer(state = {
    data: null,
    isPending: true,
  }, action){
    switch(action.type){
      case 'GET_ACCOUNT_FULFILLED':
        return Object.assign({}, state, {
            data: action.payload.data.results,
            isPending: false
        })
      default:
        return state
    }
  }


 
  export function accountChannels(state = {
    blog: null,
    instagram: null,
    twitter: null,
    youtube: null,
    isPending: true,
  }, action){
    switch(action.type){
      case 'RESET_CHANNELS':
          return Object.assign({}, state, {
            blog: null,
            instagram: null,
            twitter: null,
            youtube: null,
            isPending: true,
          })      
      case 'GET_CHANNELS_BLOG_FULFILLED':
        return Object.assign({}, state, {
            blog: action.payload.data.results,
            isPending: false
        })
    case 'GET_CHANNELS_INSTAGRAM_FULFILLED':
        return Object.assign({}, state, {
            instagram: action.payload.data.results,
            isPending: false
        })
    case 'GET_CHANNELS_TWITTER_FULFILLED':
        return Object.assign({}, state, {
            twitter: action.payload.data.results,
            isPending: false
        })
    case 'GET_CHANNELS_YOUTUBE_FULFILLED':
        return Object.assign({}, state, {
            youtube: action.payload.data.results,
            isPending: false
        })                  
      default:
        return state
    }
  } 


  
  export function channelsDetail(state = {
    data: null,
    isPending: true,
  }, action){
    switch(action.type){
      case 'GET_CHANNELS_BLOG_DETAIL_PENDING':
      case 'GET_CHANNELS_INSTAGRAM_DETAIL_PENDING':
      case 'GET_CHANNELS_YOUTUBE_DETAIL_PENDING':
      case 'GET_CHANNELS_TWITTER_DETAIL_PENDING':
          return Object.assign({}, state, {
              isPending: true
          })
      
      case 'GET_CHANNELS_RESET':
        return Object.assign({}, state, {
            data: null,
            isPending: true
        })
      case 'GET_CHANNELS_BLOG_DETAIL_FULFILLED':
        return Object.assign({}, state, {
            data:  action.payload.data.results.meta.current_page === 1 ?
                    action.payload.data.results.data : 
                    state.data.concat(action.payload.data.results.data),
            links: action.payload.data.results.links,
            isPending: false
        })
    case 'GET_CHANNELS_INSTAGRAM_DETAIL_FULFILLED':
        return Object.assign({}, state, {
            data:  action.payload.data.results.meta.current_page === 1 ?
                    action.payload.data.results.data : 
                    state.data.concat(action.payload.data.results.data),
            links: action.payload.data.results.links,
            isPending: false
        })
    case 'GET_CHANNELS_TWITTER_DETAIL_FULFILLED':
        return Object.assign({}, state, {
            data:  action.payload.data.results.meta.current_page === 1 ?
                    action.payload.data.results.data : 
                    state.data.concat(action.payload.data.results.data),
            links: action.payload.data.results.links,
            isPending: false
        })
    case 'GET_CHANNELS_YOUTUBE_DETAIL_FULFILLED':
        return Object.assign({}, state, {
            data:  action.payload.data.results.meta.current_page === 1 ?
                    action.payload.data.results.data : 
                    state.data.concat(action.payload.data.results.data),
            links: action.payload.data.results.links,
            isPending: false
        })                  
      default:
        return state
    }
  } 


 
  export function accountPortfolio(state = {
    blog: {data:[{},{},{}]},
    instagram: {data:[]},
    twitter: {data:[]},
    youtube: {data:[]},
    isPending: true,
  }, action){
    switch(action.type){
      case 'GET_PORTFOLIOS_BLOG_FULFILLED':
        return Object.assign({}, state, {
            blog: action.payload.data.results,
            isPending: false
        })
    case 'GET_PORTFOLIOS_INSTAGRAM_FULFILLED':
        return Object.assign({}, state, {
            instagram: action.payload.data.results,
            isPending: false
        })
    case 'GET_PORTFOLIOS_TWITTER_FULFILLED':
        return Object.assign({}, state, {
            twitter: action.payload.data.results,
            isPending: false
        })
    case 'GET_PORTFOLIOS_YOUTUBE_FULFILLED':
        return Object.assign({}, state, {
            youtube: action.payload.data.results,
            isPending: false
        })                  
      default:
        return state
    }
  } 



  export function accountReviews(state = {
    data: null,
    links: null,
    isPending: true,
  }, action){
    switch(action.type){
        case 'GET_REVIEWS_FULFILLED':
          return Object.assign({}, state, {
              data:  action.payload.data.results.meta.current_page === 1 ?
                      action.payload.data.results.data : 
                      state.data.concat(action.payload.data.results.data),
              links: action.payload.data.results.links,
              isPending: false
          })                
      default:
        return state
    }
  } 


export function reviewsReplies(state = {
  isPending: false
}, action){
  switch(action.type){
    case 'SEND_REPLY_FULFILLED':
      return Object.assign({}, state, {
          isPending: false
        })         
    case 'SEND_REPLY_PENDING':
      return Object.assign({}, state, {
          isPending: false
      })                        
    default:
      return state
  }
}

export function getChannelDetail(state = {
  data: null,
  isPending: true,
  active: false,
  isUpdate: false
}, action){
  const {data} = state;
  switch(action.type){
    case 'GET_CHANNELS_DETAIL_FULFILLED':
      return Object.assign({}, state, {
        data: action.payload.data.results,
        isPending: false,
        isUpdate: false
      })  

    case 'GET_CHANNELS_DETAIL_PENDING':
      return Object.assign({}, state, {
        data: null,
        isPending: true,
        active: false,
        isUpdate: false
      })  

    case 'UPDATE_ASSET_FULFILLED':
      return Object.assign({}, state, {
        isUpdate: false
      })  
    
    case 'UPDATE_ASSET_PENDING':
      return Object.assign({}, state, {
        isUpdate: true
      })     
    
    case 'EDIT_IMAGE':
   
      data[action.name] = action.value;
      return Object.assign({}, state, {
        data,
        active: !state.active
      })

    case 'EDIT_ASSETS':
      data[action.name] = action.value;
      return Object.assign({}, state, {
        data,
        active: !state.active
      })

    default:
      return state
  }        
}


export function newsRequest(state = {
  isSubmitSuccess: false
}, action){
  switch(action.type){
    case 'NEWS_REQUEST_FULFILLED':
      return Object.assign({}, state, {
        isSubmitSuccess: false
        })         
    case 'NEWS_REQUEST_PENDING':
      return Object.assign({}, state, {
        isSubmitSuccess: true
      })                        
    default:
      return state
  }
}

export function deleteAssets(state = {
  isSuccess: false,
  isFailed: false,
  message: ""
}, action){
  switch(action.type){
    case 'DELETE_ASSETS_FULFILLED':
      return Object.assign({}, state, {
        isSuccess: true,
        isFailed: false,
        message: ""
        })         
    case 'DELETE_ASSETS_PENDING':
      return Object.assign({}, state, {
        isSuccess: false,
        isFailed: false,
        message: ""
      })          
      case 'DELETE_ASSETS_REJECTED':
        return Object.assign({}, state, {
          isSuccess: false,
          isFailed: true,
          message: action.data.message
        })                         
    default:
      return state
  }
}



export function assetVerifyRequest(state = {
  isSuccess: false,
  isFailed: false,
  isPending: false,
  message: ""
}, action){
  switch(action.type){
    case 'CHANNEL_VERIFICATION_FULFILLED':
      return Object.assign({}, state, {
        isSuccess: true,
        isFailed: false,
        isPending: false,
        message: ""
        })         
    case 'CHANNEL_VERIFICATION_PENDING':
      return Object.assign({}, state, {
        isSuccess: false,
        isFailed: false,
        isPending: true,
        message: ""
      })          
    case 'CHANNEL_VERIFICATION_REJECTED':
      return Object.assign({}, state, {
        isSuccess: false,
        isFailed: true,
        isPending: false,
        message: ""
      })                         
    default:
      return state
  }
}


export function assetVerify(state = {
  data: null,
  isPending: true,
}, action){
  switch(action.type){
    case 'CHANNEL_RESULTS_FULFILLED':
      return Object.assign({}, state, {
          data: action.payload.data.results,
          isPending: false,        
      })  
    case 'CHANNEL_RESULTS_PENDING':
        return Object.assign({}, state, {
            data: null,
            isPending: true,
        })                               
    default:
      return state
  }
}


export function createAssets(state = {
  isSuccess: false,
  isFailed: false,
  isPending: false,
  message: "",
  name: "",
  duplicates: null,
}, action){
  switch(action.type){
    case 'CREATE_ASSETS_FULFILLED':
      return Object.assign({}, state, {
        isSuccess: true,
        isFailed: false,
        isPending: false,
        message: "",
        name: action.data.results.name,
        duplicates: null,
        })         
    case 'CREATE_ASSETS_PENDING':
      return Object.assign({}, state, {
        isSuccess: false,
        isFailed: false,
        isPending: true,
        message: "",
        name: "",
        duplicates: null,
      })          
    case 'CREATE_ASSETS_REJECTED':
      const {results} = action.data;
      let duplicates = null
      if(results.duplicates){
        duplicates = Object.keys(results.duplicates)
      }
      return Object.assign({}, state, {
        isSuccess: false,
        isFailed: true,
        isPending: false,
        message: action.data.message,
        name: "",
        duplicates,
      })    
    case 'CREATE_ASSETS_RESET':
      return Object.assign({}, state, {
        isSuccess: false,
        isFailed: false,
        isPending: false,
        message: "",
        name: "",
        duplicates: null,
      })                         
    default:
      return state
  }
}



export function addPortfolio(state = {
  isSuccess: false,
  isFailed: false,
  isPending: false,
  message: "",
  name: "",
  duplicates: null,
}, action){
  switch(action.type){
    case 'ADD_PORTFOLIO_FULFILLED':
      return Object.assign({}, state, {
        isSuccess: true,
        isFailed: false,
        isPending: false,
        message: "",
        duplicates: null,
        })         
    case 'ADD_PORTFOLIO_PENDING':
      return Object.assign({}, state, {
        isSuccess: false,
        isFailed: false,
        isPending: true,
        message: "",
        name: "",
        duplicates: null,
      })          
    case 'ADD_PORTFOLIO_REJECTED':
      const {results} = action.data;
      let duplicates = null
      if(results.duplicates){
        duplicates = Object.keys(results.duplicates)
      }
      return Object.assign({}, state, {
        isSuccess: false,
        isFailed: true,
        isPending: false,
        message: action.data.message,
        name: "",
        duplicates,
      })                         
    default:
      return state
  }
}


// LOGIN_TOKEN


export function getLoginToken(state = {
  instagram: null,
  youtube: null,
  twitter: null,
  isPending: true,
}, action){
  switch(action.type){
    case 'LOGIN_TOKEN_FULFILLED':
      return Object.assign({}, state, {
          ...action.payload.data.results,
          isPending: false,        
      })  
    case 'LOGIN_TOKEN_PENDING':
        return Object.assign({}, state, {
            instagram: null,
            youtube: null,
            twitter: null,
            isPending: true,
        })                               
    default:
      return state
  }
}


// ASSET_CALLBACK


export function assetCallback(state = {
  data: null,
  isPending: true,
  isError: false
}, action){
  let data = null
  switch(action.type){
    case 'ASSET_CALLBACK_FULFILLED':
      data = action.payload.data.results;
      if(!store.get('channel')){
        store.set('channel', data)
      }

      return Object.assign({}, state, {
          data,
          isPending: false,  
          isError: false,
      })  
    case 'ASSET_CALLBACK_PENDING':
        return Object.assign({}, state, {
            data: null,
            isPending: true,
            isError: false,
        })          
    case 'ASSET_CALLBACK_REJECTED':
      return Object.assign({}, state, {
          data: null,
          isPending: true,
          isError: true,
      })                                       
    default:
      return state
  }
}

const dataProfile = {
  name: "",
  categories: [],
  email:"",
  phone_number: "",
  gender: "",
  birth_date: "",
  marital_type_id: null,
  job_type_id: null,
  address: "",
  province: "",
  province_id: null,
  notif_email_task: null,
  notif_email_campaign: null,
  notif_sms_task: null,
  notif_email_contest: null,
  notif_email_pr: null,
  notif_newsletter: null,
  acc_bank_id: null,
  acc_number: "",
  acc_name: "",

  // non update field
  account_type: "",
  status: ""
}

export function getProfile(state ={
  ...dataProfile,
  isPending: true,
}, action){
  switch(action.type){
    case 'GET_PROFILE_FULFILLED':
      let data = action.payload.data.results
      let province_id = getProvinceByName(data.province)
      let gender_id = getGenderByName(data.gender)
      return Object.assign({}, state, {
          name: data.name,
          categories: data.categories.map(data => data.id),
          email:data.email,
          phone_number: data.phone_number,
          gender: data.gender,
          gender_id: gender_id,
          birth_date: data.birth_date,
          marital_type_id: data.marital_type ? data.marital_type.id : 0,
          job_type_id: data.job_type ? data.job_type.id : 0,
          address: data.address,
          province: data.province,
          province_id: province_id,
          notif_email_task: data.notification.email_task === 'true',
          notif_email_campaign: data.notification.email_campaign === 'true',
          notif_sms_task: data.notification.sms_task === 'true',
          notif_email_contest: data.notification.email_contest === 'true',
          notif_email_pr: data.notification.email_pr === 'true',
          notif_newsletter: data.notification.newsletter === 'true',
          acc_bank_id: data.acc_bank.id,
          acc_number: data.acc_number,
          acc_name: data.acc_name,
          profile_request_status: data.profile_request_status,

          account_type: data.account_type.display_name,
          status: data.status.display_name,
          isPending: false,        
      })  
    
    case 'EDIT_PROFILE': 
      return Object.assign({}, state, {
        [action.name]: action.value
      })
      
    case 'GET_PROFILE_PENDING':
        return Object.assign({}, state, {
            ...dataProfile,
            isPending: true,
        })                               
    default:
      return state
  }
}


export function updateProfile(state ={
  isPending: false
},action){
  switch(action.type){
    case "UPDATE_PROFILE_FULFILLED":
        return Object.assign({}, state, {
          isPending: false,
      })   
    case "UPDATE_PROFILE_PENDING":
        return Object.assign({}, state, {
          isPending: true,
      })         
    case "UPDATE_PROFILE_REJECTED":      
      return Object.assign({}, state, {
        isPending: false,
      })      
    default:
        return state
  }   
}


// name: Donna Nini Koten
// categories: 10,4,5,8,9
// email: donna@iblogmarket.com
// phone_number: 081210678906
// gender: Perempuan
// birth_date: 1994-09-29
// marital_type_id: 50
// job_type_id: 62
// address: Jakarta Selatan
// province_id: 31
// notif_email_task: true
// notif_email_campaign: true
// notif_sms_task: true
// notif_email_contest: true
// notif_email_pr: true
// notif_newsletter: false
// acc_bank_id: 1
// acc_number: 6080498886
// acc_name: PT. OPTIFY Intermedia Pratama